// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2XwW5","filesListContainer":"PosDisputesFiles_filesListContainer__DvRZn","filesButton":"PosDisputesFiles_filesButton__2Oe52"};